/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import variables from '../../../../css/variables.module.scss';

export const COLOUR1 = variables.ChartDark;
export const COLOUR2 = variables.ChartMedium;
export const COLOUR3 = variables.ChartLight;
export const COLOUR4 = variables.ChartBright;
export const COLOUR5 = variables.ChartPale;

export const SDG_CHART_COLORS = Array.from({ length: 17 }, (_, i) => variables[`sdg${i + 1}`]);

const UNFILLED_COLOUR = variables.ChartBaseline;

export const FILLED_AND_UNFILLED_COLOURS = [COLOUR1, UNFILLED_COLOUR];

export const CHART_DEFAULTS = {
  OPTIONS: {
    colors: [COLOUR1, COLOUR2, COLOUR3, COLOUR4, COLOUR5, ...SDG_CHART_COLORS],
    pieSliceTextStyle: {
      color: '#0c3866',
      fontSize: 8,
    },
    legend: {
      position: 'bottom'
    },
    chartArea: {
      top: 10,
      bottom: 55,
      left: 60,
      right: 10,
    },
    vAxis: {
      gridlines: {
        color: 'transparent'
      }
    },
    bar: {
      groupWidth: '50%',
      width: '80%'
    },
  }
};

export interface DataSource {
  width?: number;
  height?: number;
  chart?: string;
}

export interface GenericChartOptions {
  vAxis?: {
    title?: string;
    format?: string;
  },
  hAxis?: {
    gridlines?: {
      color: string;
    };
    textPosition?: string;
    minValue?: number;
  },
  pieHole?: number;
  pieSliceText?: string // E.g: 'label';
  bar?: {
    groupWidth: string;
    width: string;
  };
  isStacked?: boolean;
  legend?: 'none' | { position: 'none' | 'left' };
  chartArea?: {
    top: number;
    bottom: number;
    left: number;
    right: number;
  }
}
export interface GenericChartProps {
  chartType: 'LineChart' | 'PieChart' | 'ColumnChart' | 'BarChart';
  settingsSelector: string; // using string to be able to store and retrieve from db
  width?: number | string;
  height?: number | string;
  options?: string // GenericChartOptions but using a string reference to store and retrieve from db
  gridSize?: { w: number, h: number };
}

export interface UtrVariable {
  code: string;
  valueListCode?: string;
  groupCode?: string;
  subGroupCode?: string;
  /** Integration service provider code */
  integrationCode?: string;
}

export interface UtrVariables {
  [key: string]: UtrVariable
}

export enum InsightPage {
  Overview = 'overview',
  Intelligence = 'intelligence',
  Environmental = 'environmental',
  Economic = 'economic',
  Social = 'social',
  Governance = 'governance',
}

export enum ChartType {
  LineChart = 'LineChart',
  PieChart = 'PieChart',
  ColumnChart = 'ColumnChart',
  BarChart= 'BarChart'
}

export const chartTooltipOptions = {
  isHtml: true,
  textStyle: {
    color: '#fff',
  },
};
